import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import LandingPage from './components/marketing/LandingPage';
import ElevenPlusLandingPage from './components/marketing/ElevenPlusLandingPage';
import GCSEPage from './components/marketing/GCSEPage';
import UniversityPage from './components/marketing/UniversityPage';
import UniversitySubjectPage from './components/marketing/UniversitySubjectPage';
import EducatorsPage from './components/marketing/EducatorsPage';
import BrowsePage from './components/courses/BrowsePage';
import SubjectsPage from './components/marketing/SubjectsPage';
import CoursePage from './components/courses/CoursePage';
import LessonPage from './components/lessons/LessonPage';
import ExamPage from './components/exams/ExamPage';
import DashboardPage from './components/dashboard/DashboardPage';
import FlashcardsPage from './components/flashcards/FlashcardsPage';
import FlashcardReviewPage from './components/flashcards/FlashcardReviewPage';
import ManageCoursesPage from './components/admin/ManageCoursesPage';
import ManageCoursePage from './components/admin/ManageCoursePage';
import AdminLessonPreviewPage from './components/admin/AdminLessonPreviewPage';
import ManageUsersPage from './components/admin/ManageUsersPage';
import ManageOrganisationsPage from './components/admin/ManageOrganisationsPage';
import ManageOrganisationPage from './components/admin/ManageOrganisationPage';
import ManageUserPage from './components/admin/ManageUserPage';
import ClassProgressPage from './components/admin/ClassProgressPage';
import SendEmailPage from './components/admin/SendEmailPage';
import PromptTesterPage from './components/admin/PromptTesterPage';
import MarkdownPreviewPage from './components/admin/MarkdownPreviewPage';
import LoginPage from './components/auth/LoginPage';
import RegisterPage from './components/auth/RegisterPage';
import VerifyEmailPage from './components/auth/VerifyEmailPage';
import ForgotPasswordPage from './components/auth/ForgotPasswordPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import './theme.css';
import './App.css';
import './shared.css';

const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/11-plus', element: <ElevenPlusLandingPage /> },
  { path: '/gcse', element: <GCSEPage /> },
  { path: '/university', element: <UniversityPage /> },
  { path: '/university/:subjectSlug', element: <UniversitySubjectPage /> },
  { path: '/educators', element: <EducatorsPage /> },
  { path: '/subjects', element: <SubjectsPage /> },
  { path: '/browse', element: <BrowsePage /> },
  { path: '/course/:courseId', element: <CoursePage /> },
  { path: '/course/:courseId/unit/:unitId', element: <CoursePage /> },
  { path: '/lesson/:lessonId/:chatId', element: <LessonPage /> },
  { path: '/exam/:examId', element: <ExamPage /> },
  { path: '/exam/:examId/:attemptId', element: <ExamPage /> },
  { path: '/dashboard', element: <DashboardPage /> },
  { path: '/flashcards', element: <FlashcardsPage /> },
  { path: '/flashcards/review', element: <FlashcardReviewPage /> },
  { path: '/admin/courses', element: <ManageCoursesPage /> },
  { path: '/admin/courses/:courseId', element: <ManageCoursePage /> },
  { path: '/admin/lessons/:lessonId/preview', element: <AdminLessonPreviewPage /> },
  { path: '/admin/users', element: <ManageUsersPage /> },
  { path: '/admin/organisations', element: <ManageOrganisationsPage /> },
  { path: '/manage/:organisationId', element: <ManageOrganisationPage /> },
  { path: '/manage/user/:userId', element: <ManageUserPage /> },
  { path: '/organisation/progress/:itemType/:itemId', element: <ClassProgressPage /> },
  { path: '/admin/send-email', element: <SendEmailPage /> },
  { path: '/admin/prompt-tester', element: <PromptTesterPage /> },
  { path: '/preview/markdown', element: <MarkdownPreviewPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/verify-email', element: <VerifyEmailPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/activate', element: <ResetPasswordPage activation /> },
]);

function App() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let removeListener: (() => void) | undefined;
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        CapacitorApp.exitApp();
      }
    }).then((handle) => {
      removeListener = () => handle.remove();
    });

    return () => {
      removeListener?.();
    };
  }, []);

  return <RouterProvider router={router} />;
}

export default App;
